<template>
    <div class="timer ">
      <div class="row justify-center">
        <div class="q-pr-sm">
          <q-icon name="far fa-clock" size="20px" class=""/>
        </div>
        <div class="">
          <div class="row inline ">
            <div>{{$t("stepper.timer")}} </div>
            <div id="time" class="text-center text-bold q-pl-sm"></div>
          </div>
          
        </div>
      </div>
    </div>
</template>
<script>

import store from '../store';
export default {
    data() {
        return {
            timeout: null,            
            StoreStateAO : store.state.AOD,
        }
    },
    mounted() {

      
      var vm = this;
   /*   setTimeout(function(){
        vm.test();
              var fiveMinutes = vm.StoreStateAO.LandingPageTimer * 60,

            display = document.querySelector("#time");
            vm.test(fiveMinutes, display);
             if(0 == fiveMinutes){
              vm.$alert("Time up! We will redirect to main page")
              .then( () => {
                window.location.href = 'https://iakaunsit2.epf.gov.my/member/member/login'
              });
            }  
        }, 5000);*/
    },
  methods: {
  },
 
};
</script>
